function init_nieuws() {
    $('.alle-nieuws__filter__inside .alle-nieuws__filter__button').on('click', function() {
        show_loading_screen();
    });
    $('.alle-nieuws__pagination .page-link').on('click', function() {
        show_loading_screen();
    });
}

$(document).ready(function() {
    init_nieuws();
});